import { render } from "./app.vue?vue&type=template&id=2d5a07b0&scoped=true&ts=true&lang=pug"
import script from "./app.vue?vue&type=script&setup=true&lang=ts"
export * from "./app.vue?vue&type=script&setup=true&lang=ts"

import "./app.vue?vue&type=style&index=0&id=2d5a07b0&lang=stylus"
import "./app.vue?vue&type=style&index=1&id=2d5a07b0&lang=stylus&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d5a07b0"]])

export default __exports__